import React, {useState} from 'react';

import './styles.scss';
import {Column, Row} from '../layout';
import {useHistory} from 'react-router-dom';
import * as fonts from '../../util/fonts';
import {createGUID, scrollToTop} from '../../util/utility';
import {compose} from 'redux';
import {connect} from 'react-redux';
import colors from '../../util/colors';

interface menuItemSub {
  label: string;
  funct: string;
  selector: string;
  url: string;
}

interface menuItem {
  label: string;
  funct: string;
  selector: Array<string>;
  url: string;
  subItems?: menuItemSub[];
}

interface AppNavMenuProps {
  items: menuItem[];
  buStyles: any;
  busFuncMap: any;
  selectedBu: any;
}

function AppNavMenu({
  items,
  buStyles,
  busFuncMap,
  selectedBu,
}: AppNavMenuProps) {
  const history = useHistory();
  const [selectedItem, setSelectedItem] = useState<Array<string>>([]);
  const [currentPath, setCurrentPath] = useState(history.location.pathname);

  const handleSelectedItem = (item: menuItem) => {
    setSelectedItem(item.selector);
  };

  const selectedItemLine = (item: menuItem) =>
    item.selector.some(function (v: any) {
      return (history.location.pathname as string).indexOf(v) >= 0;
    }) && (
      <div
        className="app-nav-menu-selected-page"
        style={{backgroundColor: buStyles?.primaryColor || colors.blue}}
      />
    );

  const selectedItemOverBlackLine = () => (
    <div className="app-nav-menu-selected-page-label" />
  );

  const renderMenuItem = (item: menuItem) => {
    return (
      <Column key={createGUID()} style={{paddingRight: '40px'}}>
        {item.url == '' ? (
          <div
            key={item.label}
            className="app-nav-menu-item"
            style={{...fonts.M, ...fonts.SemiBold}}
            onMouseOver={() => {
              handleSelectedItem(item);
            }}>
            {item.label}
            <div>
              {selectedItemLine(item)}
              {selectedItem == item.selector && (
                <div>
                  <div>
                    <div className="app-nav-menu-selected-page-label" />
                    <div className="app-nav-menu-dropdown">
                      <div className="app-nav-menu-dropdown-content">
                        {item.subItems?.map((subItem) =>
                          busFuncMap
                            ? busFuncMap[selectedBu]?.map((func: any) => {
                                if (
                                  func?.isVisible &&
                                  subItem.funct === func?.featureTemplateAlias
                                ) {
                                  return (
                                    <div>
                                      <div
                                        key={subItem.label}
                                        className="app-nav-menu-sub-item"
                                        onClick={() => {
                                          setSelectedItem(item.selector);
                                          setCurrentPath(item.url);
                                          history.push(subItem.url);
                                          scrollToTop();
                                        }}
                                        style={{
                                          ...fonts.M,
                                          ...fonts.SemiBold,
                                          fontSize: '17px',
                                          color:
                                            buStyles?.primaryColor || colors.blue,
                                        }}>
                                        {subItem.label}
                                      </div>
                                    </div>
                                  );
                                }
                              })
                            : null
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div
            key={item.label}
            className="app-nav-menu-item"
            onClick={() => {
              setSelectedItem(item.selector);
              setCurrentPath(item.url);
              history.push(item.url);
              scrollToTop();
            }}
            onMouseOver={() => {
              handleSelectedItem(item);
            }}
            style={{...fonts.M, ...fonts.SemiBold}}>
            {item.label}
            {selectedItemLine(item)}
            {selectedItemOverBlackLine()}
          </div>
        )}
      </Column>
    );
  };

  const hasAtLeastOneChildActive = (item: any) => {
    const subItemsSelectors = item.subItems.map((subItem: any) => subItem.funct)
    return busFuncMap[selectedBu].some((buFunc: any) => subItemsSelectors.includes(buFunc.featureTemplateAlias));
  }

  return (
    <Row key={currentPath} className="app-nav-menu-row">
      {items?.map((item) =>
        busFuncMap
          ? busFuncMap[selectedBu]?.map((func: any) => {
                  if (
                    func?.isVisible &&
                    item.funct === func?.featureTemplateAlias &&
                    !item.subItems
                  ) {
                    return renderMenuItem(item);
                  } else if (
                    func?.isVisible &&
                    item.funct === func?.featureTemplateAlias &&
                    item.subItems && item.subItems.length > 0 && hasAtLeastOneChildActive(item)) {
                    return renderMenuItem(item);
                  }

            })
          : null
      )}
    </Row>
  );
}

const mapStateToProps = ({globalStyles, busFuncMap, selectedBu}: any) => ({
  buStyles: globalStyles.value,
  busFuncMap: busFuncMap.value,
  selectedBu: selectedBu.value.buId,
});

export default compose(connect(mapStateToProps)(AppNavMenu));
